var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.ops)?_c('slotted-tag',{attrs:{"no-close":"","tooltip":"Only Ops users can see this content"}},[_c('i',{staticClass:"symbol-info"}),_vm._v(" Ops only ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }